const elrondConfig = {
  url : process.env.REACT_APP_ELROND_API,
  source: process.env.REACT_APP_ENVIRONMENT
}

export default elrondConfig